import React from "react";
import { actionCreators } from "../redux/totalVisitsSagas";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const CustomDateRanges = () => {
  const dispatch = useDispatch();

  const rangeOptions = useSelector((state) => state.totalVisits.rangeOptions);
  const selectedRangeOption = useSelector((state) => state.totalVisits.selectedRangeOption);

  return (
    <MultiSelectDropdown
      options={rangeOptions}
      selectedFilters={selectedRangeOption}
      includeFilter={false}
      numberDisplayed={0}
      onSelectChange={(data) => dispatch(actionCreators.updateCustomRange(data))}
    />
  );
};

export default CustomDateRanges;
